import { render, staticRenderFns } from "./CategoryMobile.vue?vue&type=template&id=663c339c&scoped=true&"
import script from "./CategoryMobile.vue?vue&type=script&lang=js&"
export * from "./CategoryMobile.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMobile.vue?vue&type=style&index=0&id=663c339c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c339c",
  null
  
)

export default component.exports